import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsGooglenearbyComponent } from './simple-icons-googlenearby.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsGooglenearbyComponent ],
    exports:      [ SimpleIconsGooglenearbyComponent ],
    bootstrap:    []
})
export class SimpleIconsGooglenearbyModule {}
